import { EditorState, QueryMethods } from '@candulabs/craft';

import { Resolver } from 'craft/types';

import { richTextResolver, rteChildrenResolvers, rteResolvers } from './constants';

// Wrap any orphaned Slate child nodes with a new Slate node
// This happens when you drag a Slate child node (ie: a Typography node) into a non-Slate parent node
export const wrapStandaloneElements = (editorState: EditorState) => {
  const shouldHaveAsParent = rteResolvers;
  const standaloneElements = Object.values(editorState.nodes).filter(
    (node) =>
      // the node is one of the acceptable elements
      rteChildrenResolvers.includes(node.data.type as Resolver) &&
      // the node does not have a correct parent
      !shouldHaveAsParent.includes(editorState.nodes[node.data.parent]?.data.type as Resolver),
  );

  standaloneElements.forEach((node) => {
    const newRTENode = QueryMethods(editorState)
      .parseFreshNode({
        data: {
          type: richTextResolver,
          nodes: [node.id],
          parent: node.data.parent,
        },
      })
      .toNode();

    const currentParentNode = editorState.nodes[node.data.parent];
    const indexInParentNode = currentParentNode?.data.nodes.indexOf(node.id);

    if (indexInParentNode > -1) {
      currentParentNode.data.nodes.splice(indexInParentNode, 1, newRTENode.id);
    }

    // eslint-disable-next-line no-param-reassign
    node.data.parent = newRTENode.id;
    // eslint-disable-next-line no-param-reassign
    editorState.nodes[newRTENode.id] = newRTENode;
  });

  return editorState;
};
